import { GenericLoading } from "components/ui/Loader";
import { ValidationTracker } from "components/domain/ValidationTracker/ValidationTracker";
import { Form, Formik } from "formik";
import { FC, useMemo } from "react";
import { useTenantForm } from "../../hooks/useTenantForm";
import { TenantLayout } from "./TenantLayoutForm";
import { FormChangeTracker } from "components/domain/FormChangeTracker";
import { TenantFormValues } from "../../types/tenantFormValues";

interface TenantFormProps {
  riskId?: string;
  tenantId?: string;
  refreshTenants?: () => void;
  /** Bien cible explicite (tunnel parc) — par défaut le bien du risque mono-bien. */
  realEstateId?: string;
}

export const TenantForm: FC<TenantFormProps> = ({
  riskId,
  tenantId,
  refreshTenants,
  realEstateId,
}) => {
  const {
    initialValues,
    formikRef,
    submitTenant,
    validationSchema,
    handleValidationChange,
    handleFormChange,
    isLoading,
    tenant
  } = useTenantForm({
    riskId,
    tenantId,
    refreshTenants,
    realEstateId,
  });

  const formKey = useMemo(() => {
    if (tenant)
      return tenant.id
    return 'new'
  }, [tenant])

  if(isLoading){
    return <GenericLoading isParentSized loading/>
  }

  return (
    <Formik
      formKey={formKey}
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={submitTenant}
    >
      {
        ({ isValid, values }) => (
          <>
            <ValidationTracker isValid={isValid} onValidationChange={handleValidationChange} />
            <FormChangeTracker<TenantFormValues>
              values={values}
              initialValues={initialValues}
              onFormChange={handleFormChange}
            />
            <Form>
              <TenantLayout />
            </Form>
          </>
        )
      }
    </Formik>
  );
};
